export const employeeIdsForTimesheetViewMode = "employeeIdsForTimesheetViewMode";

export const openTimesheetViewMode = (employeeId: string) => {
  const url = `/my-ee-t-and-a/${employeeId}`;

  const employeeIds: string[] = JSON.parse(localStorage.getItem(employeeIdsForTimesheetViewMode) ?? JSON.stringify([]));

  const newEmployeeIds = employeeIds?.find((item) => item === employeeId) ? employeeIds : [...employeeIds, employeeId];

  localStorage.setItem(employeeIdsForTimesheetViewMode, JSON.stringify(newEmployeeIds));

  const newTab = window.open(`${url}`, "_blank", "noopener noreferrer");
  newTab && newTab.focus();
};
